export default __webpack_public_path__ + "static/25_31-a03434845cb67abe54a0d014a1fb446e.png";